import {createAction} from "redux-actions";
import * as ACTION from "./constants";

export const fetchShippingUsersSuggest = createAction(ACTION.FETCH_SHIPPING_USER_SUGGEST.REQUEST);